<template>
  <ul class="ssqNo">
    <li v-for="(item, index) in drawList" :key="index" class="ssqNo" v-show="index + 1 != drawList.length && 'true'">
      {{
      item }}</li>
    <li>
      <div class="ssqPlus"> + </div>
    </li>
    <li class="ssqNo01">{{ drawList[drawList.length - 1] }}</li>
  </ul>
</template>
<script>
import lotteryRandBallDF from "~/mixins/lotteryRandBallDF.mixins";
import lhcMixins from "~/mixins/lhc.mixins";
export default {
  mixins: [lotteryRandBallDF, lhcMixins],
  data() {
    return {
    };
  },
  props: {
    lottery: {
      type: [Object],
      default: null
    },
  },
}
</script>
<style lang="less">
.home-menu-component-df,.record-menu-components-df,.chart-menu-components-df  {
  .ssqNo li {
    width: 38px;
    height: 38px;
    border-radius: 100%;
    margin: 20px 6px 0 0;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
  }

  .ssqNo li>div.ssqPlus {
    width: 20px;
    color: #333 !important
  }

  .ssqNo {
    .ssqNo {
      background: linear-gradient(180deg, #f7846b, #d04a4c);
      border: 1px solid #ffaaab;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(255, 203, 203, .6)
    }

    .ssqNo01 {
      background: linear-gradient(180deg, #2b8ae9, #124977);
      border: 1px solid #5da9ea;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(139, 200, 253, .6)
    }
  }

  .results .ssqNo {
    display: inline-flex;
    justify-content: center;
    align-items: center
  }


}
</style>